/**
 * Who runs MOGZO, as published on the legal pages. Only the business name and a mogzo.com
 * address are shown; personal details of the owner are deliberately left out.
 */
export const OPERATOR = 'Quarkfox';
export const OPERATOR_DESCRIPTION =
  'Quarkfox, a micro enterprise registered in India under the Udyam (MSME) scheme';
export const CONTACT_EMAIL = 'hello@mogzo.com';
export const GOVERNING_COURTS = 'Lucknow, Uttar Pradesh, India';

/** Change this date whenever the privacy policy or terms change. */
export const LEGAL_UPDATED = '28 October 2026';
